import * as angular from "angular";
import {IController, IScope} from "angular";
import * as _ from "lodash";
import {AccountModel} from "../../angular/models/account.model";
import {$accountFactory} from "../../$account.factory";

export class AccountAddItemCtrl implements IController {

  accountId: string;
  excludeIds: string[];
  onAdd: Function;

  private account: AccountModel;

  /* @ngInject */
  constructor(private $account: $accountFactory, private $scope: IScope) {
  }

  $onInit() {
    if (this.accountId) {
      this.$account(this.accountId)
          .$bindCtrlToId(this.$scope, this, 'account', 'accountId');
    }
  }

  $onChanges(changes) {
    if (changes.accountId && !changes.accountId.isFirstChange()) {
      this.$onInit();
    }
  }

  getDisabledValue() {
    if (!this.account) {
      return true;
    }
    return _.findIndex(this.excludeIds, (id) => {
      return this.account.id === id;
    }) !== -1;
  }
}

angular
  .module('bringoz.admin.accounts')
  .component('accountAddItem', {
    bindings: {
      accountId: '<',
      excludeIds: '<',
      onAdd: '&'
    },
    template: require('./account-add-item.html').default,
    controller: AccountAddItemCtrl
  });
